@if (displayProgressBar()) {
  <ion-progress-bar [color]="color()" type="indeterminate" />
}
